import script from "./sf-virtual-table.vue?vue&type=script&setup=true&lang=js"
export * from "./sf-virtual-table.vue?vue&type=script&setup=true&lang=js"

import "./sf-virtual-table.vue?vue&type=style&index=0&id=140ed9cc&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-140ed9cc"]])

export default __exports__